import "@/App.css";
import { useEffect } from "react";
import { BrowserRouter, Routes, Route, Outlet } from "react-router-dom";
import { Toaster } from "sonner";
import { AuthProvider } from "./context/AuthContext";
import Header from "./components/Header";
import Footer from "./components/Footer";

import HomePage from "./pages/HomePage";
import CatalogPage from "./pages/CatalogPage";
import ProductDetailPage from "./pages/ProductDetailPage";
import ContactPage from "./pages/ContactPage";
import AdminLoginPage from "./pages/AdminLoginPage";
import AdminLayout from "./pages/AdminLayout";
import AdminDashboard from "./pages/AdminDashboard";
import AdminProducts from "./pages/AdminProducts";
import AdminCategories from "./pages/AdminCategories";
import AdminSettings from "./pages/AdminSettings";
import AdminPosPage from "./pages/AdminPosPage";
import AdminCortesPage from "./pages/AdminCortesPage";
import { api } from "./lib/api";
import { applyStoreTheme, DEFAULT_STORE_THEME_ID } from "./lib/storeThemes";

function StoreShell() {
    return (
        <div className="w-full min-w-0 overflow-x-hidden">
            <Header />
            <Outlet />
            <Footer />
        </div>
    );
}

function App() {
    useEffect(() => {
        applyStoreTheme(DEFAULT_STORE_THEME_ID);
        api.get("/settings")
            .then((r) => applyStoreTheme(r.data?.store_theme_id || DEFAULT_STORE_THEME_ID))
            .catch(() => {
                // Mantiene tema por defecto si no se pudo cargar la configuración pública.
            });
    }, []);

    return (
        <div className="App">
            <AuthProvider>
                <BrowserRouter>
                    <Routes>
                        {/* Storefront */}
                        <Route element={<StoreShell />}>
                            <Route path="/" element={<HomePage />} />
                            <Route path="/productos" element={<CatalogPage />} />
                            <Route path="/categoria/:slug" element={<CatalogPage categoryMode />} />
                            <Route path="/producto/:id" element={<ProductDetailPage />} />
                            <Route path="/contacto" element={<ContactPage />} />
                        </Route>

                        {/* Admin */}
                        <Route path="/admin/login" element={<AdminLoginPage />} />
                        <Route path="/admin" element={<AdminLayout />}>
                            <Route index element={<AdminDashboard />} />
                            <Route path="productos" element={<AdminProducts />} />
                            <Route path="pos" element={<AdminPosPage />} />
                            <Route path="cortes" element={<AdminCortesPage />} />
                            <Route path="categorias" element={<AdminCategories />} />
                            <Route path="configuracion" element={<AdminSettings />} />
                        </Route>
                    </Routes>
                </BrowserRouter>
                <Toaster position="top-right" richColors closeButton theme="light" />
            </AuthProvider>
        </div>
    );
}

export default App;
